import { RootState } from "../../../../../redux/store";

export const isItemsLoading = (state:RootState) => state.calculationTypes.itemsLoading;
export const getItemsSelect = (state:RootState) => state.calculationTypes.dropDownItems;
